import React, { useEffect, useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../config";
import CreateQuestionnaire from "../components/CreateQuestionnaire";
import "../styles/questionnairePage.css"; // Example CSS import
import { useNavigate } from "react-router-dom";

interface Questionnaire {
  id: string;
  title: string;
  description?: string;
  content?: any;
  createdAt: string;
  updatedAt: string;
}

const QuestionnairePage: React.FC = () => {
  const navigate = useNavigate(); // For navigation
  const [questionnaires, setQuestionnaires] = useState<Questionnaire[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showCreate, setShowCreate] = useState(false);

  // Fetch the list of all questionnaires
  const fetchQuestionnaires = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${SERVER_URL}/api/questionnaire`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setQuestionnaires(response.data);
      setError("");
    } catch (err: any) {
      console.error("Error fetching questionnaires:", err);
      setError("Failed to load questionnaires.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestionnaires();
  }, []);

  // Filter by searchTerm (case-insensitive)
  const filteredQuestionnaires = questionnaires.filter((q) =>
    q.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCreateToggle = () => {
    setShowCreate((prev) => !prev);
  };

  // Navigate to the edit page for a specific questionnaire
  const handleEdit = (questionnaireId: string) => {
    navigate(`/questionnaires/${questionnaireId}/edit`);
  };

  return (
    <div className="questionnaire-page-container">
      {/* Left Sidebar */}
      <aside className="questionnaire-sidebar">
        <h2>Questionnaires</h2>
        <button onClick={handleCreateToggle} className="create-button">
          {showCreate ? "Close" : "Create Questionnaire"}
        </button>
      </aside>

      {/* Main Content */}
      <div className="questionnaire-main-content">
        {showCreate ? (
          <CreateQuestionnaire />
        ) : (
          <div>
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search questionnaires by title..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p style={{ color: "red" }}>{error}</p>
            ) : filteredQuestionnaires.length === 0 ? (
              <p>No questionnaires found.</p>
            ) : (
              <ul className="questionnaire-list">
                {filteredQuestionnaires.map((q) => (
                  <li key={q.id} className="questionnaire-item">
                    <h3>{q.title}</h3>
                    {q.description && <p>{q.description}</p>}
                    {/* Edit Button */}
                    <button
                      onClick={() => handleEdit(q.id)}
                      className="edit-button"
                    >
                      Edit
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionnairePage;
